import { classEnum, type EnumType } from "./base";

// Avoid O, I, Z, S, G, J, B for prefix and sub prefix.
export const AssociateCountersEnum = new (class extends classEnum([
    {
        label: "CUSTOMER",
        value: "customer",
        start: 1,
        prefix: "C",
        subPrefix: "U",
        minLength: 4,
    },
    {
        label: "RESELLER",
        value: "reseller",
        start: 1,
        prefix: "R",
        subPrefix: "E",
        minLength: 4,
    },
    {
        label: "SUBSCRIPTION",
        value: "subscription",
        start: 1,
        prefix: "U",
        subPrefix: "C",
        minLength: 6,
    },
    {
        label: "INVOICE",
        value: "invoice",
        start: 1,
        prefix: "N",
        subPrefix: "V",
        minLength: 8,
    },
    {
        label: "PROVISION",
        value: "provision",
        start: 1,
        prefix: "V",
        subPrefix: "N",
        minLength: 6,
    },
    {
        label: "PROVISION RETURN",
        value: "provision-return",
        start: 1,
        prefix: "V",
        subPrefix: "R",
        minLength: 6,
    },
    {
        label: "BROADBAND",
        value: "broadband",
        start: 1,
        prefix: "P",
        subPrefix: "B",
        minLength: 4,
    },
    {
        label: "DEDICATED",
        value: "dedicated",
        start: 1,
        prefix: "P",
        subPrefix: "D",
        minLength: 6,
    },
    {
        label: "HOTSPOT",
        value: "hotspot",
        start: 1,
        prefix: "P",
        subPrefix: "H",
        minLength: 4,
    },
    {
        label: "DOCUMENT",
        value: "document",
        start: 1,
        prefix: "D",
        subPrefix: "C",
        minLength: 8,
    },
] as const satisfies EnumType<{
    start: number;
    prefix: string;
    subPrefix: string;
    minLength: number;
}>) {
    public minLength(name: AssociateCountersEnum.Values) {
        return this.select.find((c) => c.value === name)!.minLength;
    }
})();

export namespace AssociateCountersEnum {
    export type Labels = (typeof AssociateCountersEnum)["labels"][number];
    export type Values = (typeof AssociateCountersEnum)["values"][number];
}
